import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { apiMessage, verifyEmailRequest } from '../api';
import './Login.css';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // checking | success | error
  const [message, setMessage] = useState('');
  const calledRef = useRef(false);

  useEffect(() => {
    // StrictMode double-invokes effects in dev — guard so the single-use
    // token isn't spent on a throwaway second request.
    if (calledRef.current) return;
    calledRef.current = true;

    if (!token) {
      setStatus('error');
      setMessage('Verification link is missing its token.');
      return;
    }
    verifyEmailRequest(token)
      .then((response) => {
        setStatus('success');
        setMessage(response.data?.message || 'Email verified successfully.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(apiMessage(err, 'Verification link is invalid or has expired.'));
      });
  }, [token]);

  return (
    <div className="login-page">
      <Container fluid className="login-container">
        <Row className="g-0 login-row justify-content-center">
          <Col lg={7} className="signin-panel">
            <div className="signin-content">
              <h2 className="signin-title">Email verification</h2>
              {status === 'checking' && <p>Confirming your email address…</p>}
              {status === 'success' && <Alert variant="success" className="mb-3">{message}</Alert>}
              {status === 'error' && <Alert variant="danger" className="mb-3">{message}</Alert>}
              <div className="create-account-section">
                <p className="create-account-text">
                  <button type="button" className="create-account-link" onClick={() => navigate('/login')}>
                    Back to sign in
                  </button>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyEmail;
